<div
  #sectionContainer
  class="section-container section-page-break"
  [ngClass]="menu | productMenuBasicMethod: 'getSectionWrapperClass' : index"></div>
